import React from 'react';
import { observer, inject } from 'mobx-react';
import clsx from 'classnames';

import { ORDER_STATUS_TRACKING_MAP, RR_STATUS_TRACKING_MAP } from '@/utils/tracking/constants';
import { getChildInject, getContent, getTrans } from '@/utils/instantLoaded/tools';
import { Intent, OtherFrequentlyAsked } from '@/types/intent';
import { YOU_MAY_WANT_TO_ASK } from '@/utils/constants';
import { isMinimiseCategoryOrderSpecificEntryPoint } from '@/utils/experiment/getMinimiseCategory';

import Order from '../Order';
import NewHotQuestion from '../NewHotQuestion';

import './style.scss';

function OrderCardWithHQ(props: any) {
  const {
    order,
    hotQuestions,
    isHistory,
    kbBotId,
    kbBotName,
    isRR,
    customCallback = {},
    useUIOptimisationHotQuestion,
    otherFrequentlyAsked,
  } = props;
  const isMinimiseCategoryUI = isMinimiseCategoryOrderSpecificEntryPoint();

  const formatHotQuestions = (hotQuestions: Array<Intent>, otherFrequentlyAsked?: OtherFrequentlyAsked) => {
    const questions = hotQuestions.map((question) => ({
      id: question.intent_id,
      text: question.hotquestion_text!,
      intentType: question.intent_type!,
      intentSource: question.intent_source!,
      queryCallback: question.query_callback!,
      isRepeatedSession: question.is_repeated_session,
      extraTrackingData: {
        is_repeated_session: question.is_repeated_session ? 1 : 0,
        rr_status: RR_STATUS_TRACKING_MAP[order.return_status as keyof typeof RR_STATUS_TRACKING_MAP] ?? '',
        order_status: ORDER_STATUS_TRACKING_MAP[order.order_status as keyof typeof ORDER_STATUS_TRACKING_MAP] ?? '',
      },
    }));

    otherFrequentlyAsked
      && questions.push({
        text: getContent(otherFrequentlyAsked),
        queryCallback: otherFrequentlyAsked.query_callback,
        adhocCategoryName: otherFrequentlyAsked?.adhoc_category_name?.[0],
        isOtherFrequentlyAsked: true,
      } as any);

    return questions;
  };

  return (
    <div className={clsx('order-card-hqs chatbot-order-card-hqs', { 'minimise-category-ui': isMinimiseCategoryUI })}>
      {useUIOptimisationHotQuestion ? (
        <div className="order-card-title-ui-optimisation-hot-question">
          {getTrans(YOU_MAY_WANT_TO_ASK) || 'You may want to ask:'}
        </div>
      ) : null}

      <Order {...order} isOrderCard isRR={isRR} useUIOptimisationHotQuestion={useUIOptimisationHotQuestion} />

      <div className="divider"></div>

      <NewHotQuestion
        isOrderCard
        hotQuestions={formatHotQuestions(hotQuestions, otherFrequentlyAsked)}
        categoryName="initial"
        isHistory={isHistory}
        kbBotId={kbBotId}
        kbBotName={kbBotName}
        customCallback={customCallback}
        useUIOptimisationHotQuestion={useUIOptimisationHotQuestion}
        isMinimiseCategoryUI={isMinimiseCategoryUI}
      />
    </div>
  );
}

export default inject(getChildInject('initStore'))(observer(OrderCardWithHQ));
